import { render, staticRenderFns } from "./builder-actions.vue?vue&type=template&id=26dd70fe&"
import script from "./builder-actions.vue?vue&type=script&lang=js&"
export * from "./builder-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports